export default __webpack_public_path__ + "ebb362ae1418b646f356d6b37e3a85f5.png";